import Layout from '../pages/_Layout'

// Shared Inertia page resolver for the client and SSR entrypoints, so their
// resolution (and default-Layout wrapping) can never drift. Eager glob keeps
// resolve synchronous (also what SSR needs). A page can opt out of the shared
// layout by setting its own `.layout`.
//
// The glob matches `**/index.jsx` and nothing else. Every page Rails renders is
// an index.jsx (`render inertia: "stations/tide/index"`), so a wider `**/*.jsx`
// buys nothing and costs plenty: it also matched ExploreMap.jsx (and, until they
// were retired, TideMap.jsx and CurrentMap.jsx) and statically imported them
// here, which defeated the `import()` in _LazyMap. Rolldown said so with
// INEFFECTIVE_DYNAMIC_IMPORT. The effect was to pin react-map-gl and the map
// component onto the critical path of every station page, even though the map is
// deliberately loaded only after hydration.
//
// Eager is also the right call for the client, not just SSR. Splitting the 12
// page modules into lazy chunks was measured and made station pages *worse*:
// 213KB brotli across 19 files (7 fetched at runtime) versus 211KB across 5 with
// no runtime fetch. The shared Mantine/React chunk dominates, so there is nothing
// to win, and the page chunk would cost a round trip before hydration.
const pages = import.meta.glob('../pages/**/index.jsx', { eager: true })

export function resolvePage(name) {
  const page = pages[`../pages/${name}.jsx`]
  if (page?.default && page.default.layout === undefined) {
    page.default.layout = (content) => <Layout>{content}</Layout>
  }
  return page
}
